// extracted by mini-css-extract-plugin
export var connectionButton = "_3s-1";
export var rightPanel = "_3s-3";
export var stepDescription = "_3s-2";
export var stepIcon = "_3s-0";